module.exports = __webpack_public_path__ + "img/twitter.e551cddb.svg";